import React from 'react'
import { FiPhone, FiMail, FiMapPin, FiGlobe } from "react-icons/fi";
import { motion } from "framer-motion";

const ContactDetails = () => {
  return (
    <>
          <motion.div
          className="flex flex-wrap justify-between items-center bg-green-900 p-8 rounded-lg w-full max-w-6xl shadow-lg space-y-6 md:space-y-0"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <div className="flex items-center space-x-4 w-full sm:w-1/2 md:w-1/4">
            <FiPhone className="text-green-400 text-3xl" />
            <div>
              <p className="text-lg font-medium">Local Phone</p>
              <p className="text-sm text-gray-300">+1 (236) 427-2834</p>
            </div>
          </div>
          <div className="flex items-center space-x-4 w-full sm:w-1/2 md:w-1/4">
            <FiMail className="text-green-400 text-3xl" />
            <div>
              <p className="text-lg font-medium">Email</p>
              <p className="text-sm text-gray-300">info@beyondbloom.ca</p>
            </div>
          </div>
          <div className="flex items-center space-x-4 w-full sm:w-1/2 md:w-1/4">
            <FiGlobe className="text-green-400 text-3xl" />{" "}
            {/* Changed icon here */}
            <div>
              <p className="text-lg font-medium">Global Phone</p>
              <p className="text-sm text-gray-300">+1 (866) 231-0113</p>
            </div>
          </div>
          <div className="flex items-center space-x-4 w-full sm:w-1/2 md:w-1/4">
            <FiMapPin className="text-green-400 text-3xl" />
            <div>
              <p className="text-lg font-medium">Location</p>
              <p className="text-sm text-gray-300">
                Maple Ridge, British Columbia, Canada
              </p>
            </div>
          </div>
        </motion.div>

        {/* About Us Section */}
        <div className="mt-12 max-w-4xl text-center">
          
        </div>
    </>
  )
}

export default ContactDetails